import React, { type SelectHTMLAttributes } from "react";
import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";
import type MerchantGroup from "src/merchantgroups/objects/MerchantGroup";
import InputRenderer from "src/shared/forms/formrenderers/InputRenderer";
import type IFormInputs from "src/shared/forms/inputs/IFormInputs";
import PleaseSelect from "src/shared/forms/inputs/PleaseSelect";
import { required as Required } from "src/shared/forms/validations/Required";

export interface IMerchantGroupInputProps
  extends IFormInputs,
    SelectHTMLAttributes<HTMLSelectElement> {
  merchantGroups: MerchantGroup[];
}

/**
 * @deprecated Use MerchantGroupInputNew
 * @param props
 */
export default (props: IMerchantGroupInputProps) => {
  const {
    merchantGroups,
    inputID,
    label = <FormattedMessage id="merchant_groups" />,
    ...rest
  } = props;

  return (
    <Field
      name={inputID}
      label={label}
      type="select"
      component={InputRenderer}
      validate={[Required]}
      {...rest}
    >
      <PleaseSelect />
      {merchantGroups.map((merchantGroup) => {
        return (
          <option
            key={merchantGroup.merchantGroupUUID}
            value={merchantGroup.merchantGroupUUID}
          >
            {merchantGroup.merchantGroupName}
          </option>
        );
      })}
    </Field>
  );
};
